import { animate, scroll } from 'https://cdn.jsdelivr.net/npm/motion@11.11.13/+esm';

const setupScroll = function () {
  document.querySelectorAll('.section-shop-pay').forEach((section) => {
    const gridMedia = section.querySelector('.grid__item-media');
    if (window.matchMedia('(min-width: 40em').matches) {
      scroll(animate(gridMedia, { y: ['-80%', '-20%'] }, { ease: 'easeInOut' }), {
        target: gridMedia,
        offset: ['start end', 'end start'],
      });
    } else {
      scroll(animate(gridMedia, { y: ['-30%', '30%'], scale: [1.3, 1.3] }, { ease: 'easeInOut' }), {
        target: gridMedia,
        offset: ['start end', 'end start'],
      });
    }
  });
};

window.addEventListener('DOMContentLoaded', setupScroll);

window.addEventListener('resize', debounce(setupScroll, 300));
